import React, { useCallback } from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoToFundOwnershipProps } from './GoToFundOwnership.props';

const GoToFundOwnership = ({ fundOwnershipURL, measurementDateSlug }: GoToFundOwnershipProps) => {
  const navigate = useNavigate();

  const redirectToFundOwnershipPage = useCallback(() => {
    navigate(measurementDateSlug ? `${fundOwnershipURL}?date=${measurementDateSlug}` : fundOwnershipURL);
  }, [fundOwnershipURL, navigate, measurementDateSlug]);

  return (
    <Button variant="outlined" color="primary" onClick={redirectToFundOwnershipPage} endIcon={<ArrowBackIcon />}>
      Add Ownership
    </Button>
  );
};

export default GoToFundOwnership;
